export const EDIT_FILTERVALUEFINANCIAL = "EDIT_FILTERVALUEFINANCIAL";
export const EDIT_FILTERVALUEFINANCIAL_SUCCESS = "EDIT_FILTERVALUEFINANCIAL_SUCCESS";
export const EDIT_FILTERVALUEFINANCIAL_FAIL = "EDIT_FILTERVALUEFINANCIAL_FAIL";

export const LOAD_FILTERVALUESFINANCIAL = "LOAD_FILTERVALUESFINANCIAL";
export const LOAD_FILTERVALUESFINANCIAL_SUCCESS = "LOAD_FILTERVALUESFINANCIAL_SUCCESS";
export const LOAD_FILTERVALUESFINANCIAL_FAIL = "LOAD_FILTERVALUESFINANCIAL_FAIL";

export const LOAD_LAYOUTFINANCIAL = "LOAD_LAYOUTFINANCIAL";
export const LOAD_LAYOUTFINANCIAL_SUCCESS = "LOAD_LAYOUTFINANCIAL_SUCCESS";
export const LOAD_LAYOUTFINANCIAL_FAIL = "LOAD_LAYOUTFINANCIAL_FAIL";

export const LOAD_FINANCIALYEAR = "LOAD_FINANCIALYEAR";
export const LOAD_FINANCIALYEAR_SUCCESS = "LOAD_FINANCIALYEAR_SUCCESS";
export const LOAD_FINANCIALYEAR_FAIL = "LOAD_FINANCIALYEAR_FAIL";

const GET_DEFAULTGROUPS = "GET_DEFAULTGROUPS";
const GET_DEFAULTGROUPS_SUCCESS = "GET_DEFAULTGROUPS_SUCCESS";
const GET_DEFAULTGROUPS_FAIL = "GET_DEFAULTGROUPS_FAIL";

export default function filterValue(
  state = {
    data: [],
    isLoading: true,
    hasError: false,
    uploading: false,
    layoutsName: [],
    isLoadinglayouts: false,
    isLoadingYears: false,
    years: [],
    defaultGroups: [],
  },
  action,
) {
  switch (action.type) {
    case LOAD_FILTERVALUESFINANCIAL: {
      return Object.assign({}, state, {
        isLoading: true,
        hasErrored: false,
      });
    }

    case LOAD_FILTERVALUESFINANCIAL_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        message: action.error.message,
        hasErrored: true,
      });
    }

    case LOAD_FILTERVALUESFINANCIAL_SUCCESS: {
      return Object.assign({}, state, {
        data: action.payload.data,
        isLoading: false,
        hasErrored: false,
      });
    }

    case EDIT_FILTERVALUEFINANCIAL: {
      return {
        ...state,
        uploading: true,
      };
    }

    case EDIT_FILTERVALUEFINANCIAL_SUCCESS: {
      return {
        ...state,
        uploading: false,
      };
    }

    case EDIT_FILTERVALUEFINANCIAL_FAIL: {
      return {
        ...state,
        uploading: false,
        hasError: true,
      };
    }

    case LOAD_LAYOUTFINANCIAL: {
      return {
        ...state,
        isLoadinglayouts: true,
      };
    }

    case LOAD_LAYOUTFINANCIAL_SUCCESS: {
      return {
        ...state,
        isLoadinglayouts: false,
        layoutsName: action.payload.data,
      };
    }

    case LOAD_LAYOUTFINANCIAL_FAIL: {
      return {
        ...state,
        hasError: true,
        isLoadinglayouts: false,
      };
    }

    case LOAD_FINANCIALYEAR: {
      return {
        ...state,
        isLoadingYears: true,
      };
    }
    case LOAD_FINANCIALYEAR_SUCCESS: {
      return {
        ...state,
        years: action.payload.data,
        isLoadingYears: false,
      };
    }
    case LOAD_FINANCIALYEAR_FAIL: {
      return {
        ...state,
        hasError: true,
        isLoadingYears: false,
      };
    }

    case GET_DEFAULTGROUPS_SUCCESS: {
      return {
        ...state,
        defaultGroups: action.payload.data,
      };
    }

    case GET_DEFAULTGROUPS_FAIL: {
      return {
        ...state,
        hasError: true,
      };
    }

    default:
      return state;
  }
}

export function getFilterValuesFinancial(yearId) {
  return {
    type: LOAD_FILTERVALUESFINANCIAL,
    payload: {
      request: {
        url: "FinancialClousure/" + yearId,
      },
    },
  };
}

export function getFinancialYears() {
  return {
    type: LOAD_FINANCIALYEAR,
    payload: {
      request: {
        url: "FinancialClousure/Years",
      },
    },
  };
}

export function getLayoutsAffectedByFinancialTag() {
  return {
    type: LOAD_LAYOUTFINANCIAL,
    payload: {
      request: {
        url: "FinancialClousure/Layouts",
      },
    },
  };
}

/**
 *
 * @param {Object} filterValue
 * @param {number} year Id FilterValue (Tag de Financial Year)
 * @returns Action // REQUEST
 */
export function editFilterValueFinancial(filterValue, year) {
  let { id } = filterValue;

  return {
    type: EDIT_FILTERVALUEFINANCIAL,
    payload: {
      request: {
        url: "FinancialClousure/" + id,
        method: "PUT",
        data: filterValue,
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getFilterValuesFinancial(year));
        },
      },
    },
  };
}

export function getGroupIdsDefaults() {
  return {
    type: GET_DEFAULTGROUPS,
    payload: {
      request: {
        url: "FinancialClousure/GroupsDefault",
      },
    },
  };
}
